import React from 'react';

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
  noGutters?: boolean;
}

export const Row: React.FC<RowProps> = ({ className = '', children, noGutters = false, ...props }) => {
  const gutterClasses = noGutters ? '' : '-mx-3';
  return (
    <div className={`flex flex-wrap ${gutterClasses} ${className || ''}`} {...props}>
      {children}
    </div>
  );
};
